import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const SuccessPage = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-md-offset-2 col-md-8 text-align-center">
                        <h3>{t('contactSentSuccess')}</h3>
                    </div>
                </div>
                <br />
                <div className="row text-center">{t('infoWillBeUpdated')}</div>
            </div>
        </Fragment>
    );
};

export default SuccessPage;
